import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import type { MessageTemplate } from "@features/templates/api";
import { Button, Popconfirm, Space, Tag, Tooltip } from "antd";
import type { ColumnsType } from "antd/es/table";

const channelLabels: Record<string, string> = {
  email: "Email",
  telegram: "Telegram",
  both: "Все",
};

export const templateColumns = (
  onEdit: (tpl: MessageTemplate) => void,
  onDelete: (id: string) => void,
): ColumnsType<MessageTemplate> => [
  { title: "Название", dataIndex: "name" },
  { title: "Slug", dataIndex: "slug", width: 180 },
  {
    title: "Канал",
    dataIndex: "channel",
    width: 100,
    render: (v: string) => <Tag>{channelLabels[v] ?? v}</Tag>,
  },
  {
    title: "Активен",
    dataIndex: "is_active",
    width: 80,
    render: (v: boolean) => (v ? <Tag color="green">Да</Tag> : <Tag>Нет</Tag>),
  },
  {
    title: "",
    width: 80,
    render: (_: unknown, record: MessageTemplate) => (
      <Space>
        <Tooltip title="Редактировать">
          <Button size="small" type="text" icon={<EditOutlined />} onClick={() => onEdit(record)} />
        </Tooltip>
        <Popconfirm title="Удалить шаблон?" onConfirm={() => onDelete(record.id)}>
          <Tooltip title="Удалить">
            <Button size="small" type="text" danger icon={<DeleteOutlined />} />
          </Tooltip>
        </Popconfirm>
      </Space>
    ),
  },
];
